const jquery = $;

const set$ElementMaxHeight = ($element, maxHeight) => {
  $element.each((_, child) => {
    child.style.maxHeight = maxHeight !== null ? `${maxHeight}px` : maxHeight;
  });
};

const doSetModalHeights = (resetHeights = false) => {
  const $container = $('.dictionary-modal-with-dynamic-inner-scroll');
  if ($container.length < 1) {
    return;
  }

  const $modal = $container.closest('.ui.modal');
  const $actions = $modal.children('.actions');
  const $header = $container.find('.modal-header').closest('.four.wide.column');
  const $subcontent = $container.find('.subcontent');
  const $notFormChildren = $subcontent.children(':not(form)');
  const $formChild = $subcontent.children('form');
  const $formSegment = $formChild.children('.segment');
  let $formContent = $formSegment.children('.ui.tab');
  if ($formContent.length === 0) {
    $formContent = $formSegment;
  }
  const $formTabContent = $formContent.children('.sylius-tabular-form');
  const $formTabContentChildren = $formTabContent.children();

  if (resetHeights) {
    set$ElementMaxHeight($container, null);
    set$ElementMaxHeight($subcontent, null);
    set$ElementMaxHeight($formChild, null);
    set$ElementMaxHeight($formSegment, null);
    set$ElementMaxHeight($formContent, null);
    set$ElementMaxHeight($formTabContentChildren, null);
  }
  setTimeout(() => {
    const containerHeight = $modal[0].offsetHeight - $actions[0].offsetHeight;
    const subcontenHeight = containerHeight - $header[0].offsetHeight;

    let takenHeight = 0;
    $notFormChildren.each((_, child) => {
      const styles = window.getComputedStyle(child);
      const margin = parseFloat(styles['marginTop']) + parseFloat(styles['marginBottom']);
      takenHeight += Math.ceil(child.offsetHeight + margin);
    });
    const contentHeight = subcontenHeight - takenHeight;
    const scrollContentHeight = contentHeight - 12;

    set$ElementMaxHeight($container, containerHeight);
    set$ElementMaxHeight($subcontent, subcontenHeight);
    set$ElementMaxHeight($formChild, contentHeight);
    set$ElementMaxHeight($formSegment, contentHeight);
    set$ElementMaxHeight($formContent, scrollContentHeight);
    set$ElementMaxHeight($formTabContentChildren, scrollContentHeight);
  }, 0);
};

$.fn.extend({
  initModalDynamicScroll() {
    doSetModalHeights();
  },
});

jquery(document).ready(() => {
  doSetModalHeights();

  window.addEventListener('resize', () => {
    doSetModalHeights(true);
  });
});
